// import { useState, useEffect } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { HeartIcon, HopeLogo, LittleHeroesLogo,DecreaseFontSize, ResetFontSize, IncreaseFontSize } from './Assets';
import BtnComp from './Buttons/BtnComp';
import '../styles/Header.css';

function Header(
  // {
  // defaultHeadingFontSize,
  // defaultSubHeadingFontSize,
  // defaultParagraphFontSize
  // }
  ) {
  const [accessibility, setAccessibility] = useState(false);
  const handleAccessClicked = () => setAccessibility(!accessibility);

  // Minimum and maximum font sizes
  // const minFontSize = 0.75;
  // const maxFontSize = 2.25;

  // State to manage the font sizes and font family
  // const [headingFontSize, setHeadingFontSize] = useState(defaultHeadingFontSize);
  // const [subHeadingFontSize, setSubHeadingFontSize] = useState(defaultSubHeadingFontSize);
  // const [paragraphFontSize, setParagraphFontSize] = useState(defaultParagraphFontSize);

  // Load font settings from local storage on component mount
  // useEffect(() => {
  //   const storedHeadingFontSize = localStorage.getItem('headingFontSize');
  //   const storedSubHeadingFontSize = localStorage.getItem('subHeadingFontSize');
  //   const storedParagraphFontSize = localStorage.getItem('paragraphFontSize');

  //   if (storedHeadingFontSize) {
  //     setHeadingFontSize(parseInt(storedHeadingFontSize));
  //   }

  //   if (storedSubHeadingFontSize) {
  //     setSubHeadingFontSize(parseInt(storedSubHeadingFontSize));
  //   }
    
  //   if (storedParagraphFontSize) {
  //     setParagraphFontSize(parseInt(storedParagraphFontSize));
  //   }
  // }, []);

  // Update local storage when font settings change
  // useEffect(() => {
  //   localStorage.setItem('headingFontSize', headingFontSize);
  // }, [headingFontSize]);

  // useEffect(() => {
  //   localStorage.setItem('subHeadingFontSize', subHeadingFontSize);
  // }, [subHeadingFontSize]);

  // useEffect(() => {
  //   localStorage.setItem('paragraphFontSize', paragraphFontSize);
  // }, [paragraphFontSize]);

  // Functions to increase and decrease font sizes
  // const increaseFontSizes = () => {
  //   setHeadingFontSize(prevSize => Math.min(prevSize + 0.1, maxFontSize));
  //   setSubHeadingFontSize(prevSize => Math.min(prevSize + 0.1, maxFontSize));
  //   setParagraphFontSize(prevSize => Math.min(prevSize + 0.1, maxFontSize));
  // };

  // const decreaseFontSizes = () => {
  //   setHeadingFontSize(prevSize => Math.max(prevSize - 0.1, minFontSize));
  //   setSubHeadingFontSize(prevSize => Math.max(prevSize - 0.1, minFontSize));
  //   setParagraphFontSize(prevSize => Math.max(prevSize - 0.1, minFontSize));
  // };

  // Function to reset font sizes and font family to defaults
  // const resetFontSettings = () => {
  //   setHeadingFontSize(defaultHeadingFontSize);
  //   setSubHeadingFontSize(defaultSubHeadingFontSize);
  //   setParagraphFontSize(defaultParagraphFontSize);
  // };

  return (
    <>
      <div className={`accessibility ${accessibility ? "show" : ""}`}>
        <div className="font-size-controls">
          <button 
            className="access-btn" 
            title="Decrease font size"
            // onClick={decreaseFontSizes}
          >
            <img src={DecreaseFontSize} alt="Decrease font size" />
          </button>
          <button 
            className="access-btn" 
            title="Increase font size"
            // onClick={increaseFontSizes}
          >
            <img src={IncreaseFontSize} alt="Increase font size" />
          </button>
          <button 
            className="access-btn" 
            title="Reset font size"
            // onClick={resetFontSettings}
          >
            <img src={ResetFontSize} alt="Reset font size" />
          </button>
        </div>
      </div>
      <div className="header">
        <div className="header_btn">
          <a 
            href="https://www.paypal.com/donate/?hosted_button_id=J7NBS6WZ67U52" target="_blank" rel="noreferrer noopener" className="donate-link"
          >
            <BtnComp
              btnIcon={HeartIcon}
              btnText="Donate" 
              btnType="primary-btn"
              btnLength="short-btn"
            />
          </a>
        </div>
        <div className="logos">
          <Link to="/" className="logo-container">
            <img src={HopeLogo} alt="HOPE" className="img-size" />
          </Link>
          <Link to="/little-heroes-big-missions" className="logo-container">
            <img src={LittleHeroesLogo} alt="Little Heroes" className="img-size" />
          </Link>
        </div>
        <div className="header_btn" onClick={handleAccessClicked}>
          <BtnComp
            btnIcon=""
            btnText="Accessibility" 
            btnType="secondary-btn"
            btnLength="short-btn"
          />
        </div>
      </div>
    </>
  )
}

export default Header